import React, { useState, useEffect } from 'react';
import { Button } from '../../atoms/button';
import { InputField } from '../../atoms/input-field';
import { ManagePayPalUpdateForm } from './ManagePayPalDialog';
import { PayPalCharityDetailsODataModel } from '../../../types/templates/PayPalCharityDetailsODataModel';

const GST_MULTIPLIER = 0.1;

const UpdatePayPalDetailsForm = function UpdatePayPalDetailsForm({
    selectedCharity,
    onSubmit,
    isLoading,
}: ManagePayPalUpdateForm) {
    const [charity, setCharity] = useState<PayPalCharityDetailsODataModel>(selectedCharity);

    useEffect(() => {
        setCharity({
            ...selectedCharity,
            FeeFraction: Number((selectedCharity.FeeFraction * 100).toFixed(2)),
        });
    }, [selectedCharity]);

    const onFeeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = Number(e.target.value);

        if (value < 0) {
            return;
        }

        setCharity((prev) => ({
            ...prev,
            FeeFraction: value,
        }));
    };

    const adminFee = charity?.FeeFraction || 0;
    const gstFee = Number((adminFee * GST_MULTIPLIER).toFixed(2));
    const totalAdminFee = Number((adminFee + gstFee).toFixed(2));

    return (
        <div className="layout-grouping-children">
            <InputField
                id="ge-admin-fee"
                type="number"
                label="Enter GE Admin Fee (%):"
                onChange={onFeeChange}
                value={adminFee}
            />
            <InputField
                id="ge-gst-fee"
                type="number"
                label="GST (10%):"
                value={gstFee}
                disabled
            />
            <InputField
                id="ge-total-fee"
                type="number"
                label="Total GE Fee (%):"
                description="*Excludes PayPal cost to charity"
                value={totalAdminFee}
                disabled
            />
            <Button
                id="submit-paypal-details"
                appearance="new-primary"
                onClick={() => onSubmit({
                    ...charity,
                    FeeFraction: charity.FeeFraction / 100,
                })}
                isLoading={isLoading}
                disabled={isLoading}
            >
                Save
            </Button>
        </div>
    );
};

export default UpdatePayPalDetailsForm;
